/**
 * Created by fers on 05.02.16.
 */

import {injectIntl, FormattedMessage, IntlShape} from 'react-intl';
import React from 'react';
import PropTypes from 'prop-types';
import EmptyContent from '../view/box/system/EmptyContent.react';
import ScenarioBox from './ScenarioBox.react';
import { PageInfo } from '../../common/types/types';

interface ScenarioGridProps {
    edges: object;
    forDevelopers?: boolean;
    getUrl?: (...args: unknown[]) => unknown;
    intl?: object;
    metadata: object;
    pageInfo: PageInfo;
    relay: object;
    urlMapping?: object;
}

class ScenarioGrid extends React.Component<ScenarioGridProps> {

    static propTypes = {
        edges: PropTypes.object.isRequired,
        forDevelopers: PropTypes.bool,
        getUrl: PropTypes.func,
		intl: PropTypes.object,
        metadata: PropTypes.object.isRequired,
        pageInfo: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        urlMapping: PropTypes.object
    };

    static defaultProps = {
        renderLink: true
    };


    nextPage = () => {
        const cursor = this.props.pageInfo.endCursor;
        this.props.relay.setVariables({ after: cursor });
    };

    render() {
        const { urlMapping, metadata } = this.props;

        const list = this.props.edges.edges.map(({node}) => node);

        let primaryKey = metadata.getPrimaryKey().key;

        if (list.length === 0) {
            return <EmptyContent></EmptyContent>;
        } else {
            return (
                <div>
                    <div className="scenarioGridList">
                        {list.map((item) => {
                            if (item) {
                                return (
                                    <ScenarioBox forDevelopers={this.props.forDevelopers} key={item[primaryKey] + "_gridlist"} metadata={metadata}
                                                 scenario={item} urlMapping={urlMapping}/>
                                );
                            }
                        })}
                    </div>
                    {this.props.pageInfo && this.props.pageInfo.hasNextPage ? <div className="btn btn-default" onClick={this.nextPage}><FormattedMessage defaultMessage="Load more…" id="msg.loadMore" /></div> : null}
                </div>
            );
        }
    }
}

export default injectIntl(ScenarioGrid);
